import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Dispatch } from "redux";
import { connect, useSelector } from "react-redux";
import _ from "lodash";
import classnames from "classnames/bind";
import actions from "../../../redux/actions";
import FilterSection from "./FilterSection";
import SortSection from "./SortSection";
import Workshop from "./Workshop";
import MapSection from "../../MapSection";
import FilterCategory from "./FilterCategory";
import searchicon from "../../../images/searchicon.svg";
import {
  IState,
  IVehicle,
  ITWorkshop,
  IModal,
  ICoordinate,
  Replacement,
  ICountry,
  LocationCategory,
} from "../../../interface";
import style from "./index.module.scss";
import { getLangs, getLocations } from "../../../services";
import { usePosition } from "../../../hooks/use-position";
import moment from "moment";
import { ModalHref } from "../../../interface/emnu";
import Modal from "../../Modal";
import Contact from "../../Contact";
import Book from "../../Book";
import Paginator from "../../Paginator";
import {
  irelandLocations,
  PERPAGEFORLARGE,
  PREPAGE,
  RETAIL_OUTLET,
  UNDETECT_LOCATION_PERMISSIONS,
} from "../../../constants";
import Loading from "../../Loading";
import { useLoadScript } from "@react-google-maps/api";
import { libraries } from "../../../config/mapConfig";
import localesReplacement from "../../../utils/localesReplacement";
import { UnderMaintenance } from "../../UnderMaintenance";
import { Library } from "@googlemaps/js-api-loader";
import { useMediaQuery } from "react-responsive";

/* eslint-disable */

const cx = classnames.bind(style);

type Libraries =
  | "drawing"
  | "geometry"
  | "localContext"
  | "places"
  | "visualization";

interface IProps {
  state: IState;
  modal: IModal;
  country: ICountry;
  replacements: Replacement;
  setVehicle: (value: IVehicle) => void;
  setWorkshops: (value: ITWorkshop[]) => void;
  setModal: (value: IModal) => void;
  locationCategoriesList: LocationCategory[] | null;
}

const WhereToBuy = React.memo(
  function _WhereToBuy(props: IProps) {
    const {
      state,
      modal,
      replacements,
      setWorkshops,
      setModal,
      country,
      locationCategoriesList,
    } = props;
    const isLargeDesktop = useMediaQuery({ minWidth: 1440 });
    const [positon] = usePosition(props.country.name, replacements);
    const currentPositon =
      props.country.name !== "Georgia"
        ? positon
        : { lat: 41.69411, lng: 44.83368 };
    const [searchText, setSearchText] = useState({
      text: "",
      isClicked: false,
    });
    const navigate = useNavigate();
    const [mapAccord, setMapAccord] = useState<boolean>(false);
    const [mapAccordMobile, setMapAccordMobile] = useState<boolean>(false);
    const [filterOverlay, setFilterOverlay] = useState<boolean>(false);
    const [selectedLocation, setSelectedLocation] = useState<ITWorkshop>();
    //const [locationMap, setLocationMap] = useState<ITWorkshop[]>();
    const [workshopsForMap, setWorkshopsForMap] = useState();
    const [underMaintnance, setUnderMaintenance] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const [pageIndex, setPageIndex] = useState<number>(0);
    const [mounted, setMounted] = useState<boolean>(true);

    const isIreland = useSelector(
      (state: { isIreland: boolean }) => state.isIreland
    );

    // const isWelshWorkshop = (workshop: { address: { townOrCity: string; county: string; }; }) => {
    //   return (
    //     irelandLocations.includes(workshop.address.townOrCity)
    //     // welshLocations.includes(workshop.address.county)
    //   );
    // };

    // useEffect(() => {
    //   if (state.workshops && state.workshops.length) {
    //     const filteredWorkshops = filterNonWelshWorkshops(state.workshops);
    //     setWorkshops(filteredWorkshops);
    //   }
    // }, [state.workshops, isIreland]);
    const getWorkshop = (currentPositon: ICoordinate) => {
      const kmToMiles = (value: number) => {
        return value * 0.621371;
      };

      const extraFilter: Record<string, string> = {};

      if (!state.filter.distance) {
        if (!state.isMiles) {
          extraFilter.distanceInMiles = kmToMiles(
            state.distanceInMilesOrKM
          ).toString();
        } else {
          extraFilter.distanceInMiles = state.distanceInMilesOrKM.toString();
        }
      } else {
        if (!state.isMiles) {
          extraFilter.distanceInMiles = kmToMiles(
            parseInt(state.filter.distance)
          ).toString();
        } else {
          extraFilter.distanceInMiles = state.filter.distance;
        }
      }
      let data = {
        page: pageIndex + 1,
        perPage: isLargeDesktop
          ? PERPAGEFORLARGE
          : PREPAGE,
        currentLatitude: currentPositon.lat,
        currentLongitude: currentPositon.lng,
        sortBy: state.sort,
        locationCategoryIds: state.filter.locationCategories
          ?.filter((x) => x !== "0")
          ?.join(","),
        productCategoryIds: state.filter.productCategories?.join(","),
        locationTypeIds: state.filter.locationType?.join(","),
        openingHourFrom: moment(state.filter.openHours, "HH")
          .minutes(0)
          .format("HH:mm"),
        openingHourTo: _.isEqual(
          moment(state.filter.closeHours, "HH").format("HH:mm"),
          "00:00"
        )
          ? "23:59"
          : moment(state.filter.closeHours, "HH").format("HH:mm"),
        ...extraFilter,
        onlyCastrolCertified: state.filter.locationCategories?.some(
          (x) => x === "0"
        ),
        countryIds: isIreland ? 102 : country.id,
        isMiles: state.isMiles.toString(),
        text: searchText.text,
        // distanceInMilesOrKM: state.distanceInMilesOrKM,
      };

      setMounted(false);

      if (validateGetLocationsAPI(data)) {
        getLocations(data
        ).then((d) => {
          setWorkshops(d.data.items);
          setCount(d.data.total);
          setMounted(true);
          if (d.status !== 200) {
            setUnderMaintenance(true);
          }
          if (!state.enableWtbDistanceFilter) {
            setMounted(false);
            data.perPage = count ? count : data.perPage;
            data.page = 0;
            getLocations(data).then((d) => {
              if (d !== undefined) {
                setWorkshopsForMap(d.data.items);
                setMounted(true);
              }
            });
          }
        });
      }
    };
    const validateGetLocationsAPI = (data: any) => {
      let isValid = true;
      if (data.distanceInMiles === "false") {
        isValid = false;
      }
      return isValid;
    };

    const validateEnableWtbDistanceFilter = (data: any) => {
      return data;
    };

    const ref = useRef<ICoordinate>();
    const refState = useRef<IState>();
    useEffect(() => {
      if (
        currentPositon &&
        (!_.isEqual(ref.current, currentPositon) ||
          !_.isEqual(refState.current, state))
      ) {
        ref.current = currentPositon;
        refState.current = state;
        !!country.id &&
          getWorkshop(
            state.filter.address?.coordinate
              ? state.filter.address?.coordinate
              : currentPositon
          );
      }
      else if (
        currentPositon &&
        state.filter.openHours &&
        state.filter.closeHours &&
        state.filter.distance &&
        (!_.isEqual(ref.current, currentPositon) ||
          !_.isEqual(refState.current, state))
      ) {
        ref.current = currentPositon;
        refState.current = state;
        !!country.id &&
          getWorkshop(
            state.filter.address?.coordinate
              ? state.filter.address?.coordinate
              : currentPositon
          );
      }
    }, [
      pageIndex,
      state.sort,
      state.filter.productCategories,
      state.filter.locationCategories,
      state.filter.locationType,
      state.filter.openHours,
      state.filter.closeHours,
      state.filter.distance,
      state.filter.address,
      currentPositon,
      country,
      state.distanceInMilesOrKM,
      state.enableWtbDistanceFilter,
      searchText.isClicked,
    ]);

    // const filterNonWelshWorkshops = (Workshops: any[]) => {
    //   return Workshops.filter((Workshop: { address: { townOrCity: string; county: string; line1:string,line2:string}; }) => !isWelshWorkshop(Workshop))
    // }

    // useEffect(() => {
    //   if (state.workshops && state.workshops.length) {
    //     const filteredWorkshops = filterNonWelshWorkshops(state.workshops);
    //     setWorkshops(filteredWorkshops);
    //   }
    // }, [state.workshops]);

    useEffect(() => {
      const body = document.body;
      window.scrollTo(0, 0);
      filterOverlay || state.modal.visibie
        ? body.classList.add("no-scroll")
        : body.classList.remove("no-scroll");
    }, [filterOverlay]);

    //Open Contact Modal
    const openContactModal = (workshop: ITWorkshop) => {
      setModal({ visibie: true, href: ModalHref.Contact });
      setSelectedLocation(workshop);
    };

    //Open Book Modal
    const openBookModal = (workshop: ITWorkshop) => {
      setModal({ visibie: true, href: ModalHref.Book });
      setSelectedLocation(workshop);
    };

    //Scroll top
    useEffect(() => {
      if (modal.visibie) {
        window.scrollTo(0, 0);
      }
    }, [modal]);

    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: process.env.REACT_APP_GOOGLE_KEY as string,
      id: "script-loader",
      libraries: libraries as Library[],
      // ...otherOptions
    });

    if (loadError) {
      return <>Map cannot be loaded right now, sorry.</>;
    }

    const locCatNames = _.map(
      state.filter.locationCategories,
      (lc) =>
        _.find(locationCategoriesList, (l) => _.isEqual(lc, l.id.toString()))
          ?.name
    );

    useEffect(() => {
      sessionStorage.removeItem(UNDETECT_LOCATION_PERMISSIONS);
    }, []);

    const handleBack = () => {
      navigate(-1);
    };

    useEffect(() => {
      getLangs().then((d) => {
        if (d.status !== 200) {
          setUnderMaintenance(true);
        }
      });
    }, []);

    useEffect(() => {
      if (
        country.name === "United States" ||
        country.isoCode === "USA" ||
        country.name === "Malayisa" ||
        country.isoCode === "MYS"
      ) {
        setFilterOverlay(true);
      }
    }, [country]);

    const handleSearch = () => {
      if (searchText.text !== "") {
        setSearchText((prev) => {
          return {
            ...prev,
            isClicked: true,
          };
        });
      }
    };

    return (
      <>
        {/* Main container */}
        {isLoaded &&
          !_.isUndefined(currentPositon) &&
          (underMaintnance ? (
            <div>
              <UnderMaintenance replacements={replacements} />
            </div>
          ) : (
            <div className={cx("content")}>
              {/* Top section for filter */}
              <FilterSection
                replacements={replacements}
                setOverlay={setFilterOverlay}
                position={currentPositon}
              />

              <div className={cx("results")}>
                <h3>
                  {localesReplacement(
                    replacements,
                    "Find the right Products or Services near you"
                  )}
                </h3>
                <p className={cx("total")}>
                  {count} {localesReplacement(replacements, "places near you")}
                </p>
                <div className={cx("filter-category-container")}>
                  <input
                    className={cx("search-box")}
                    value={searchText.text}
                    placeholder={localesReplacement(
                      replacements,
                      "Search workshop by name"
                    )}
                    onChange={(e) =>
                      setSearchText((prev) => {
                        return {
                          ...prev,
                          isClicked: false,
                          text: e.target.value,
                        };
                      })
                    }
                  />
                  <button
                    className={cx("search-button")}
                    onClick={handleSearch}
                  >
                    <img src={searchicon} />
                  </button>
                </div>
                <div className={cx("result-block", { expanded: mapAccord })}>
                  {/* List result */}
                  <div
                    className={cx({
                      "result-list": true,
                      "hide-mobile": mapAccordMobile,
                    })}
                  >
                    <div className={cx("operations")}>
                      <div className={cx("block")}>
                        {filterOverlay ? (
                          <div
                            className={cx("toggle-filter", "on")}
                            onClick={() => setFilterOverlay(false)}
                          >
                            {localesReplacement(replacements, "Hide Filter")}
                          </div>
                        ) : (
                          <div
                            className={cx("toggle-filter")}
                            onClick={() => setFilterOverlay(true)}
                          >
                            {localesReplacement(replacements, "Show Filter")}
                          </div>
                        )}
                      </div>
                      <div className={cx("block", "sort-block")}>
                        <SortSection
                          setAccord={setMapAccordMobile}
                          accord={mapAccordMobile}
                        />
                      </div>
                    </div>
                    <FilterCategory
                      overlay={filterOverlay}
                      setOverlay={setFilterOverlay}
                    />
                    {!!country.isoCode && (
                      <>
                        {
                          _.includes(locCatNames, RETAIL_OUTLET) ? null : (
                            <div className="static-map">
                              <MapSection
                                accord={mapAccord}
                                mapAccordMobile={mapAccordMobile}
                                setAccord={setMapAccord}
                                setAccordMobile={setMapAccordMobile}
                                //dataList={locationMap}
                                manualLocation={state.filter.address}
                                onContactClick={openContactModal}
                                country={country.name}
                                enableWtbDistanceFilter={
                                  state.enableWtbDistanceFilter
                                    ? state.enableWtbDistanceFilter
                                    : false
                                }
                                workshopsForMap={workshopsForMap}
                                noPosition={true}
                              />
                            </div>
                          )}
                      </>
                    )}
                    {mounted &&
                      !mapAccordMobile &&
                      (state.workshops.length ? (
                        <ul
                          className={cx(
                            "workshops",
                            undefined
                          )}
                        >
                          {_.map(state.workshops, (workshop, index) => (
                            <li key={index}>
                              <Workshop
                                setAccord={setMapAccordMobile}
                                dataList={workshop}
                                onContactClick={openContactModal}
                                onBookClick={openBookModal}
                              />
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className={cx("no-match")}>
                          {localesReplacement(
                            replacements,
                            "No Castrol workshops/services available within your area of search"
                          )}
                          .
                        </p>
                      ))}
                    {mounted && !mapAccordMobile && (
                      <Paginator
                        count={Math.ceil(
                          count /
                          PREPAGE)
                        }
                        pageIndex={pageIndex}
                        handlePageClick={setPageIndex}
                        className="pagination"
                      />
                    )}
                    {!mounted && <Loading className="wtb-loading" />}
                  </div>
                  {/* Map */}
                  {mounted && !!country.isoCode && (
                    <>
                      {_.includes(locCatNames, RETAIL_OUTLET) ? null : (
                        <div
                          className={cx({
                            "map-section": true,
                            "expanded-mobile": mapAccordMobile,
                          })}
                        >
                          <MapSection
                            accord={mapAccord}
                            mapAccordMobile={mapAccordMobile}
                            setAccord={setMapAccord}
                            setAccordMobile={setMapAccordMobile}
                            //dataList={locationMap}
                            manualLocation={state.filter.address}
                            onContactClick={openContactModal}
                            country={country.name}
                            enableWtbDistanceFilter={
                              state.enableWtbDistanceFilter
                                ? state.enableWtbDistanceFilter
                                : false
                            }
                            workshopsForMap={workshopsForMap}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        {_.isEqual(modal.href, ModalHref.Contact) && modal.visibie && (
          <Modal className="abs-modal">
            <Contact
              dismiss={() => setModal({ visibie: false, href: 0 })}
              selected={selectedLocation}
            />
          </Modal>
        )}
        {_.isEqual(modal.href, ModalHref.Book) && modal.visibie && (
          <Modal className="abs-modal">
            <Book
              dismiss={() => setModal({ visibie: false, href: 0 })}
              selected={selectedLocation}
            />
          </Modal>
        )}
      </>
    );
  },
  (prev, next) => {
    return _.isEqual(prev.state, next.state) ? true : false;
  }
);

const mapStateToProps = (state: IState) => ({
  state: state,
  modal: state.modal,
  replacements: state.replacements,
  country: state.country,
  locationCategoriesList: state.locationCategoriesList,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setVehicle: (vehicle: IVehicle) => dispatch(actions.setVehicle(vehicle)),
  setWorkshops: (value: ITWorkshop[]) => dispatch(actions.setWorkshops(value)),
  setModal: (value: IModal) => dispatch(actions.setModal(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WhereToBuy);
